import React, { useState, useEffect } from 'react';
import './Navbar.css';
import logo from '../../Images/Logo_Invis.png';
import { Link } from "react-router-dom";


function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(v => !v);
  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') closeMenu(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  return (
    <>
      <div className="navbar">
        <div className="logo-wrapper">
          <Link to="/">
            <img src={logo} alt="Captain's Connections Logo" className="logo-image" />
          </Link>
        </div>

        <button
          className="menu-toggle"
          aria-label="Menu"
          aria-expanded={menuOpen}
          aria-controls="primary-navigation"
          onClick={toggleMenu}
        >
          ☰
        </button>

        <div id="primary-navigation" className={`nav-links ${menuOpen ? 'active' : ''}`}>
          <a href="/services" onClick={closeMenu}>Our Services In Antigua</a>
          <a href="/destinations-and-itineraries" onClick={closeMenu}>Destinations & Itineraries</a>
          <a href="/contact" onClick={closeMenu}>
            <button className="contact-button">Contact</button>
          </a>
        </div>
      </div>

      {menuOpen && <div className="nav-backdrop open" onClick={closeMenu} />}
    </>
  );
}

export default Navbar;
